import { render, staticRenderFns } from "./MondaiPdfRender.vue?vue&type=template&id=6a167aa1&"
import script from "./MondaiPdfRender.vue?vue&type=script&lang=ts&"
export * from "./MondaiPdfRender.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports